import React from "react";
import { Tag } from "@jsq/ds/core";
import { type ExtensionFieldValueObjectType } from "~/graphql/supergraphTypes";
import * as styles from "./styles_vanilla.css";

interface EnumerationFieldRendererProps {
  value: ExtensionFieldValueObjectType;
  enumValues: Array<{
    id: string;
    enumName: string;
    enumValueCode: string;
    enumValueLabel: string;
  }>;
}

/**
 * Cell renderer for enumeration extension fields
 * Uses @jsq/ds Tag component for consistent styling with the design system
 */
export const EnumerationFieldRenderer: React.FC<EnumerationFieldRendererProps> = ({
  value,
}) => {
  const enumValue = value.enumValue;

  // Handle case where no enum value is set
  if (!enumValue) {
    // Check if there's a string value that might represent an enum code
    if (value.stringValue) {
      return (
        <Tag
          variant="neutral"
          label={value.stringValue}
          title={`Enum code: ${value.stringValue}`}
        />
      );
    }
    return <span className={styles.emptyValue}>—</span>;
  }

  // Use the enum value label for display, with fallbacks
  const displayLabel = enumValue.enumValueLabel || enumValue.enumValueCode || "Unknown";

  return (
    <Tag
      variant="neutral"
      label={displayLabel}
      title={`${displayLabel} (${enumValue.enumValueCode})`}
    />
  );
};
